import { TEMPLATES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// 1 trash
const trash_template_request = () => {
  return {
    type: templatesTypes.publish.request
  }
}

const trash_template_success = (response) => {
  return {
    type: templatesTypes.publish.success,
    payload: response.data
  }
}

const trash_single_template_success = (response) => {
  return {
    type: templatesTypes.publish.single,
    payload: response.data
  }
}

const trash_template_failure = (messages) => {
  return {
    type: templatesTypes.publish.failure,
    payload: messages
  }
}

const trash_template = (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( trash_template_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.post(
      formatRoute(TEMPLATES_ROUTES.trash, {id: template_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The template status has changed to: Trash.')
      if ( index ) {
        dispatch( trash_template_success(response) )

      } else {
        dispatch( trash_single_template_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error moving template to trash"]
      }
      dispatch( trash_template_failure( errors ) )
    })
  }
}

export {trash_template}



// WEBPACK FOOTER //
// ./src/js/actions/templates/trash.js